"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeExperimentsAsAttributes = void 0;
/* @ngInject */
function writeExperimentsAsAttributes(experimentManager) {
    var generateActiveExperimentList = function (experimentList) {
        return Object.keys(experimentList)
            .filter(function (experiment) { return experimentList[experiment] === 'true'; })
            .map(function (experiment) { return experiment.split('.').pop(); });
    };
    var setExperimentsAsAttributes = function (experiments, element) {
        experiments.forEach(function (experiment) {
            element.attr("data-experiment-" + experiment, '');
        });
    };
    return {
        restrict: 'A',
        compile: function (templateElement) {
            var experimentList = experimentManager.$$getExperimentsObj();
            var activeExperimentList = generateActiveExperimentList(experimentList);
            setExperimentsAsAttributes(activeExperimentList, templateElement);
            return undefined;
        },
    };
}
exports.writeExperimentsAsAttributes = writeExperimentsAsAttributes;
